import React, { Children, cloneElement, isValidElement } from 'react';
import PropTypes from 'prop-types';

const blockEl = 'ui__tabs';

const Tabs = ({ value, onChange, children }) => {
  const handleOnTabClick = (currentTabIndex) => () => {
    onChange(currentTabIndex);
  };

  return (
    <div className={blockEl}>
      {

        Children.map(Children.toArray(children), (child, index) => {
          if (!isValidElement(child) || child.type.displayName !== 'Tab') {
            return null;
          }

          return cloneElement(child, {
            ...child.props,
            isActive: value === index,
            onClick: handleOnTabClick(index)
          });
        })
    }
    </div>
  );
};

Tabs.propTypes = {
  value: PropTypes.number,
  onChange: PropTypes.func
};

Tabs.defaultProps = {
  value: 0,
  onChange: Function.prototype
};

export default Tabs;
